import dayjs, { Dayjs } from 'dayjs';
import { default as Picker } from 'react-datepicker';
import { useState, useCallback } from 'react';

interface IDatePickerProps {
  onChange?: (dateFrom?: Dayjs, dateTo?: Dayjs) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  dateFrom?: Dayjs;
  dateTo?: Dayjs;
  isReadOnly?: boolean;
}

export const DateRangePickerInput = (props: IDatePickerProps) => {
  const [month, setMonth] = useState<number>(props.dateFrom?.month() ?? dayjs().month());
  const [year, setYear] = useState<number>(props.dateFrom?.year() ?? dayjs().year());

  const handleMonthChange = useCallback((newMonth: number) => {
    setMonth(newMonth);
  }, []);

  const handleYearChange = useCallback((newYear: number) => {
    setYear(newYear);
  }, []);

  return (
    <div>
      <div className='flex justify-between mb-2.5'>
        <select
          className='bg-ice dark:bg-eerie-black px-2 py-1 rounded'
          value={month}
          onChange={(e) => handleMonthChange(Number(e.target.value))}
          disabled={props.isReadOnly}
        >
          {Array.from({ length: 12 }).map((_, i) => (
            <option key={i} value={i}>
              {dayjs().month(i).format('MMMM')}
            </option>
          ))}
        </select>

        <select
          value={year}
          onChange={(e) => handleYearChange(Number(e.target.value))}
          disabled={props.isReadOnly}
          className='bg-ice dark:bg-eerie-black px-2 py-1 rounded'
        >
          {Array.from({ length: 10 }).map((_, i) => {
            const yearOption = dayjs().year() - 5 + i;
            return (
              <option key={yearOption} value={yearOption}>
                {yearOption}
              </option>
            );
          })}
        </select>
      </div>

      <Picker
        onChange={(dates) => {
          if (props.isReadOnly) return;
          if (!props.onChange) return;

          const startDate = dates[0];
          const endDate = dates[1];
          const dateFrom = startDate != null ? dayjs(startDate) : undefined;
          const dateTo = endDate != null ? dayjs(endDate) : undefined;

          props.onChange(dateFrom, dateTo);
        }}
        minDate={props.minDate?.toDate()}
        maxDate={props.maxDate?.toDate()}
        startDate={props.dateFrom?.toDate()}
        endDate={props.dateTo?.toDate()}
        readOnly={props.isReadOnly}
        selectsRange
        inline
        openToDate={dayjs().year(year).month(month).toDate()}
        onMonthChange={(newMonth) => {
          setMonth(newMonth.getMonth());
          setYear(newMonth.getFullYear());
        }}
      />
    </div>
  );
};
